module.exports = __webpack_public_path__ + "static/media/ic_full_screen_exit.4ed2f6f5.svg";